import { useMutation } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';

import { toast } from '@savgroup-front-common/core/atoms/Toast';
import { SellerService } from '@/api';

import messages from '../messages';
import adaptOnboardingActivities from '../OnboardingActivities.adpaters';
import { OnboardingActivitiesSubmitValues } from '../OnboardingActivities.types';

const useSavePersonalizedDemoContextCommand = () => {
  const params = useParams<{ emailId: string }>();
  const navigate = useNavigate();

  const { mutateAsync: handleSubmitSalesLead, isLoading } = useMutation(
    [],
    async (data: OnboardingActivitiesSubmitValues) => {
      if (!params.emailId) {
        return undefined;
      }

      const adaptedOnboardingActivities = adaptOnboardingActivities({
        activities: data,
      });

      const response = await SellerService.savePersonalizedDemoContextCommand({
        email: params.emailId,
        personalizationKeys: adaptedOnboardingActivities,
      });

      if (response.failure) {
        toast.error(messages.saveContextError);

        return undefined;
      }

      navigate(`/onboarding/${params.emailId}/confirmation`);

      return undefined;
    },
  );

  return { handleSubmitSalesLead, isLoading };
};

export default useSavePersonalizedDemoContextCommand;
